import { useEffect, useState } from 'react'

interface OsloClock {
    time: string | null
    open: boolean | null
}

const readOslo = (): OsloClock => {
    const now = new Date()

    const time = new Intl.DateTimeFormat('nb-NO', {
        timeZone: 'Europe/Oslo',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    }).format(now)

    const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Oslo',
        weekday: 'short',
        hour: 'numeric',
        hour12: false
    }).formatToParts(now)

    const weekday = parts.find(part => part.type === 'weekday')?.value ?? ''
    const hour = Number(parts.find(part => part.type === 'hour')?.value ?? '0')
    const weekend = weekday === 'Sat' || weekday === 'Sun'

    return {
        time,
        open: !weekend && hour >= 8 && hour < 16
    }
}

/** Oslo time and whether support answers the phone (weekdays 08 to 16). Null until mounted. */
export const useOsloClock = (): OsloClock => {
    const [clock, setClock] = useState<OsloClock>({ time: null, open: null })

    useEffect(() => {
        setClock(readOslo())

        const id = window.setInterval(() => setClock(readOslo()), 20000)

        return () => window.clearInterval(id)
    }, [])

    return clock
}
